// import { getCurrentInstance } from 'vue';

export const mixinsCom = {
    computed: {
        iptVal: {  //组件绑定的属性
          get() {
            return this.option.cptDataForm.iptVal || '';
          },
          set(value) {
            this.option.cptDataForm.iptVal = value;
          }
        },
        cptData: {  //组件绑定的属性
          get() {
            return this.option.cptDataForm.cptData || {};
          },
          set(value) {
            this.option.cptDataForm.cptData = value;
          }
        },
        tableData: {  //组件绑定的属性
          get() {
            return this.option.cptDataForm.tableData || [];
          },
          set(value) {
            this.option.cptDataForm.tableData = value;
          }
        },
        checkedValDate: {  //组件绑定的属性
          get() {
            return this.option.cptDataForm.checkedValDate || [];
          },
          set(value) {
            this.option.cptDataForm.checkedValDate = value;
          }
        },
        daterangeData: {  //组件绑定的属性
          get() {
            return this.option.cptDataForm.daterangeData || [];
          },
          set(value) {
            this.option.cptDataForm.daterangeData = value;
          }
        },
        newData: {  //后台返回的数据集
          get() {
            return this.option.cptDataForm.resData || null;
          },
          set(value) {
            this.option.cptDataForm.resData = value;
          }
        },
        tabs: {  //组件绑定的属性
          get() {
            return this.option.cptDataForm.resData || null;
          },
          set(value) {
            this.option.cptDataForm.resData = value;
          }
        },
        activeValue: {  //组件绑定的属性
            get() {
              return this.option.cptDataForm.iptVal || '';
            },
            set(value) {
              this.option.cptDataForm.iptVal = value;
            }
          },
        jsFunFlag: { //组件绑定的属性
          get() {
            return this.option.cptDataForm.jsFunFlag || false;
          },
          set(value) {
            this.option.cptDataForm.jsFunFlag = value;
          }
        },
    },
    watch: {
        'option.cptDataForm.resData': {
            handler(newValue, oldValue) {
              // console.log(newValue, oldValue,'newValue, oldValue');
              if(!newValue){return};
              if( ["cpt-table"].includes(this.current.cptKey) ){
                  this.pageChange({
                    current: 1,
                    pageSize: this.option.attribute.pageSize || 5,
                  });
              }else if( ["cpt-tab"].includes(this.current.cptKey) ){
                this.verifyTabGroupConsistency()
                this.changeTab(this.option.attribute.isDefault, 0)
              }else if( ["cpt-scroll-table"].includes(this.current.cptKey) ){
                this.scrollTable();
                this.setDefualtRowIndex();
              }else if( ["cpt-scroll-list"].includes(this.current.cptKey) ){
                this.scrollTable();
              }else if( ["cpt-water-prop", "cpt-ring-pie"].includes(this.current.cptKey) || /cpt-chart-*/.test(this.current.cptKey) ){
                this.processData(this.option.cptDataForm, newValue, this.option.cptDataForm.jsFunFlag)
                this.loadChart(this.option.attribute);
              }else{
                this.processData(this.option.cptDataForm, newValue, this.option.cptDataForm.jsFunFlag);
              }

            },
            deep: false,
          },
    },
    methods: {
    }

}